import { GithubAuthDataService } from '../service/github-auth-data.service';
import { AuthEvent, AuthService } from '@openmfp/portal-ui-lib';
import { filter } from 'rxjs';

export function initializeSessionRefreshHandler(
  githubAuthDataService: GithubAuthDataService,
  authService: AuthService,
) {
  return (): void => {
    authService.authEvents
      .pipe(filter((event: AuthEvent) => event === AuthEvent.AUTH_REFRESHED))
      .subscribe({
        next: async (): Promise<void> => {
          try {
            await githubAuthDataService.removeGithubAuthData();
          } catch (e) {
            console.error('Github tokens not removed', e);
          }
        },
      });
  };
}
